export default {
  members: (state) => state.members,
};
